import React from 'react';

export const Container = (props) => (
  <svg className={props.className} width={24} height={24} aria-hidden={true} viewBox={`0 0 24 24`}>
    {props.children}
  </svg>
);

const OuterRing = (props) => (
  <path
    className={props.className}
    d="M12,2A10,10,0,1,1,2,12,10,10,0,0,1,12,2m0-2A12,12,0,1,0,24,12,12,12,0,0,0,12,0Z"
  />
);

const InnerRing = (props) => <circle className={props.className} cx="12" cy="12" r="8" />;

const Background = (props) => <circle className={props.className} cx="12" cy="12" r="12" />;

export interface IRadioIndicatorSVGProps {
  containerClassName?: string;
  backgroundClassName?: string;
  outerRingClassName?: string;
  innerRingClassName?: string;
}

export const RadioIndicatorSVG: React.SFC<IRadioIndicatorSVGProps> = (props) => (
  <Container className={props.containerClassName}>
    <Background className={props.backgroundClassName} />
    <OuterRing className={props.outerRingClassName} />
    <InnerRing className={props.innerRingClassName} />
  </Container>
);
